// api/facilities.js - Facility Management API

import { apiClient } from './client';

class FacilityAPI {
  constructor(client) {
    this.client = client;
  }

  // ========== BASIC CRUD ==========

  async getFacilities(campaignId) {
    return this.client.request(`/api/facilities?campaign_id=${campaignId}`);
  }

  async getFacility(facilityId) {
    return this.client.request(`/api/facilities/${facilityId}`);
  }

  async createFacility(campaignId, facilityType, facilityName, gridRow, gridCol, level = 1) {
    const result = await this.client.request('/api/facilities', {
      method: 'POST',
      body: JSON.stringify({
        campaign_id: campaignId,
        facility_type: facilityType,
        facility_name: facilityName,
        level,
        grid_row: gridRow,
        grid_col: gridCol,
        is_active: true,
      }),
    });

    // Ensure is_active is set on the returned object
    return {
      ...result,
      is_active: true
    };
  }

  async updateFacility(facilityId, updates) {
    return this.client.request(`/api/facilities/${facilityId}`, {
      method: 'PATCH',
      body: JSON.stringify(updates),
    });
  }

  async deleteFacility(facilityId) {
    return this.client.request(`/api/facilities/${facilityId}`, {
      method: 'DELETE',
    });
  }

  // ========== UPGRADES & MANAGEMENT ==========

  async upgradeFacility(facilityId, newLevel) {
    return this.updateFacility(facilityId, { level: newLevel });
  }

  async toggleFacility(facilityId, isActive) {
    return this.updateFacility(facilityId, { is_active: isActive });
  }

  // ========== BATCH OPERATIONS ==========

  async batchUpdateFacilities(updates) {
    const promises = updates.map(({ facilityId, updates }) => 
      this.updateFacility(facilityId, updates)
    );
    return Promise.all(promises);
  }

  // ========== QUERIES ==========

  async getActiveFacilities(campaignId) {
    const facilities = await this.getFacilities(campaignId);
    return facilities.filter(f => f.is_active);
  }

  async getFacilitiesByType(campaignId, facilityType) {
    const facilities = await this.getFacilities(campaignId);
    return facilities.filter(f => f.facility_type === facilityType);
  }

  async getFacilityAtPosition(campaignId, gridRow, gridCol) {
    const facilities = await this.getFacilities(campaignId);
    return facilities.find(f => f.grid_row === gridRow && f.grid_col === gridCol);
  }
}

// Export singleton instance
export const facilityAPI = new FacilityAPI(apiClient);

// Also export class
export default FacilityAPI;